import React, { PureComponent } from 'react';
import {
  FaAndroid,
  FaApple,
  FaCube,
  FaMobileAlt,
  FaTimes
} from 'react-icons/fa';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { firebaseConnect, getVal, isLoaded } from 'react-redux-firebase';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import styled from 'styled-components';

import locale from './locale.js';

const ListHeading = styled.div`
  margin: 1em 0 0 0;
  display: flex;
  align-items: center;
  color: ${props => props.color};
  > *:not(:first-child) {
    margin-left: 0.4em;
  }
`;

const List = styled.ul`
  margin: 0.3em 0;
`;

const ListItem = styled.li`
  line-height: 1.4em;
  a {
    color: inherit;
  }
`;

const SubList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  font-size: 0.7em;
  color: #a2a2a2;
  line-height: initial;
  > li {
    &:before {
      content: '├';
    }
    &:last-of-type:before {
      content: '└';
    }
  }
`;

const CompatibilityList = ({ label, items, color, icon }) => (
  <>
    <ListHeading color={color}>
      {icon}
      <div>{label}</div>
    </ListHeading>
    <List>
      {items.map(item => (
        <ListItem key={item.name}>
          {item.link && (
            <a
              dangerouslySetInnerHTML={{ __html: item.name }}
              href={item.link}
              rel="noopener noreferrer"
              target="_blank"
            />
          )}
          {!item.link && (
            <div dangerouslySetInnerHTML={{ __html: item.name }} />
          )}
          {item.subRequirements && (
            <SubList>
              {item.subRequirements.map(subitem => (
                <li dangerouslySetInnerHTML={{ __html: subitem }} key={subitem}>
                  {}
                </li>
              ))}
            </SubList>
          )}
        </ListItem>
      ))}
    </List>
  </>
);

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8em 0;
  background: #2e2e2e;
  letter-spacing: 0.1em;
  :first-child {
    border-radius: 0.3em 0.3em 0 0;
  }
  > *:not(:first-child) {
    margin-left: 0.2em;
  }
`;

const Info = styled.div`
  padding: 1em;
`;

const SectionFooter = styled.div`
  font-size: 0.7em;
  padding: 0 2.5em 2em 2.5em;
`;

const OSSection = ({ title, requirements, icon }) => {
  const { compatible, incompatible, ar, footer } = requirements;
  return (
    <>
      <Header>
        {icon}
        <div>{title}</div>
      </Header>
      <Info>
        <CompatibilityList
          color="#FF2E2E"
          icon={<FaTimes size="1.25em" />}
          items={incompatible}
          label={<Translate id="supportedDevices.incompatible" />}
        />
        <CompatibilityList
          color="#67ADFF"
          icon={<FaMobileAlt size="1.25em" />}
          items={compatible}
          label={<Translate id="supportedDevices.compatible" />}
        />
        {ar && (
          <CompatibilityList
            color="#9BFFD1"
            icon={<FaCube size="1.25em" />}
            items={ar}
            label={<Translate id="supportedDevices.ar" />}
          />
        )}
      </Info>
      {footer && <SectionFooter dangerouslySetInnerHTML={{ __html: footer }} />}
    </>
  );
};

const Wrapper = styled.div`
  background: #171717;
  color: white;
  letter-spacing: 0.1em;
  border-radius: 0.3em;
`;

class SupportedDevices extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslation(locale);
  }
  render() {
    const { deviceCompatibility } = this.props;
    if (!isLoaded(deviceCompatibility)) {
      return null;
    }
    const { android, ios } = deviceCompatibility;
    return (
      <Wrapper>
        <OSSection
          icon={<FaApple size="1.25em" />}
          requirements={ios}
          title={<Translate id="supportedDevices.ios" />}
        />
        <OSSection
          icon={<FaAndroid size="1.25em" />}
          requirements={android}
          title={<Translate id="supportedDevices.android" />}
        />
      </Wrapper>
    );
  }
}

SupportedDevices.propTypes = {
  gameId: PropTypes.string.isRequired
};

/**
 * Map Redux State to props
 //  */
const mapStateToProps = ({ firebase }, { gameId }) => {
  return {
    deviceCompatibility: getVal(
      firebase.data,
      `games/${gameId}/deviceCompatibility`
    )
  };
};

export default compose(
  withLocalize,
  connect(mapStateToProps, null),
  firebaseConnect(({ gameId }) => [`/games/${gameId}/deviceCompatibility`])
)(SupportedDevices);
